import { CheckCircleIcon, UsersIcon } from '@heroicons/react/24/outline';
import { SidebarMenu } from 'app/components/SidebarMenu';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Groups } from '../Groups/Loadable';

export enum MANAGE_PANELS {
  OVERVIEW = 0,
  GROUPS = 1,
  USERS = 2,
  RESPONSES = 3,
}

export function Sidebar({ selected }) {
  const navigate = useNavigate();
  const [panel, setPanel] = useState(selected);

  const openPanel = (panel, url) => {
    setPanel(panel);
    navigate(url, { replace: false });
  };

  return (
    <div className="main-side-nav px-2">
      <div className=" h-full shadow-right overflow-y-auto rounded-xl hidden lg:flex flex-col z-10  lg:w-72 scroll-bar">
        <h1 className={'text-2xl py-6 pl-6 howio-font-md'}>Manage</h1>
        <SidebarMenu
          title="Users"
          open={e => openPanel(MANAGE_PANELS.GROUPS, '/manage')}
          icon={<UsersIcon className={'h6 w-6 mr-2'} />}
          isOpen={panel === MANAGE_PANELS.GROUPS}
        >
          {/* <Groups /> */}
        </SidebarMenu>
        <SidebarMenu
          title="Responses"
          open={e => openPanel(MANAGE_PANELS.RESPONSES, '/manage/responses')}
          icon={<CheckCircleIcon className={'h6 w-6 mr-2'} />}
          isOpen={panel === MANAGE_PANELS.RESPONSES}
        />
      </div>
    </div>
  );
}
